import React, {CSSProperties, PureComponent} from "react";
import {SceneryType} from "../../store/settings/SceneryType";
import {cssHelper} from "../../shared/utils/cssHelper";
import styles from "./level-map.module.css";
import {
    IAggregatedQuestion,
    ICategory,
    ILevelMapAggregatedTile,
    ILevelMapTileProgress,
    TileType
} from "../../store/game/types";
import {animateTile} from "./animateTile";

export interface TileProps extends ILevelMapAggregatedTile, ILevelMapTileProgress {
    readonly scenery: SceneryType;
    readonly isClickable: boolean;
    readonly isExitFound: boolean;
    readonly category?: ICategory;
    readonly question?: IAggregatedQuestion;
    readonly onClick?: () => void;
}

export class Tile extends PureComponent<TileProps> {
    static DEFAULT_CATEGORY: Partial<ICategory> = {
        title: "Geography",
        name: "geography",
        backgroundColor: "#ffcc00",
        imageUrl: "https://cdn.quizz.land/categories/geography.png"
    };

    render() {
        if (this.props.tileType === TileType.Blocked)
            return (<></>);

        if (!this.props.isRevealed) {
            return (
                <div className={styles.tile_back} onClick={this.props.onClick}>
                    <i className={`${styles.icon} ${this.props.scenery}_unrevealed_tile`}/>
                </div>
            );
        }

        const className = this.getClassName();
        const icon = this.renderTileIcon();
        const answer = this.renderTileAnswer();
        const score = this.renderTileScore();

        return (
            <div className={className.toString()} onClick={this.props.onClick}>
                {answer}
                {score}
                {icon}
            </div>
        );
    }

    private getClassName() {
        const className = cssHelper(styles.tile)
            .add(styles.tile_clickable, this.props.isClickable)
            .add(`${this.props.scenery}_tile_bg`);

        if (!this.props.isAnswered) {
            className
                .add(styles.bonus_indicator, this.props.isBonusQuestion)
                .add(styles.double_indicator, this.props.questionCount === 2);
        }

        return className;
    }

    private renderTileIcon() {
        let style: CSSProperties | undefined;
        const className = cssHelper(styles.icon);

        className
            .add(styles.cards_icon, this.props.tileType === TileType.CardsGame)
            .add(styles.chest_icon, this.props.tileType === TileType.ChestGame)
            .add(styles.exit_icon, this.props.tileType === TileType.Exit && this.props.isExitFound)
            .add(styles.unrevealed_exit_icon, this.props.tileType === TileType.Exit && !this.props.isExitFound);

        if (this.props.tileType === TileType.SimpleQuestion) {
            const question = this.props.question;
            const category = this.props.category || Tile.DEFAULT_CATEGORY;

            className.add(styles.category_icon)
                .add(styles.difficulty)
                .add(styles[`difficulty_${question?.difficulty || 0}`]);

            style = {
                backgroundImage: `url(${category.imageUrl})`,
                backgroundColor: category.backgroundColor,
            };
        }

        return (<i className={className.toString()} style={style}/>);
    }

    private renderTileAnswer() {
        if (!this.props.isAnswered)
            return;

        const className = cssHelper(styles.tile_answer)
            .add(styles.right_icon, this.props.isRight)
            .add(styles.wrong_icon, !this.props.isRight);

        return (<i className={className.toString()}/>);
    }

    private renderTileScore() {
        if (this.props.score == null)
            return;

        return (
            <div className={styles.tile_score}>
                {this.props.score}
            </div>
        );
    }
}

export default animateTile(Tile);